import React from 'react';

const Status = (props) => {

  return (
      <div className={"table-status " + props.type}>
        {props.type === 'hidden' && <>
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="4" cy="4" r="3" fill="#D48A0B"/>
            </svg>
            <span>{props.type}</span>
        </>}
        {props.type === 'visible' && <>
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="4" cy="4" r="3" fill="#227965"/>
            </svg>
            <span>{props.type}</span>
        </>}
      </div>
  );
};

export default Status;